import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "ic_24/Download",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M10.4094 13.5915C11.2878 14.4705 12.7124 14.4709 13.5914 13.5925L13.5924 13.5915L16.0006 11.1833C16.2785 10.876 16.2546 10.4018 15.9474 10.1239C15.6613 9.8653 15.2257 9.86576 14.9402 10.125L12.7457 12.3203L12.7509 4.75002C12.7509 4.33578 12.4151 4 12.0009 4C11.5867 4 11.2509 4.33578 11.2509 4.74999L11.2441 12.306L9.06165 10.125C8.76859 9.83215 8.29363 9.83232 8.00077 10.1254C7.70792 10.4184 7.7081 10.8934 8.00116 11.1863L10.4094 13.5915Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .15
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M19.0715 14.0023C18.7165 14.0023 18.4286 14.3381 18.4286 14.7523V17.7523C18.4286 18.1665 18.1408 18.5023 17.7858 18.5023H6.21423C5.85919 18.5023 5.57138 18.1665 5.57138 17.7523V14.7523C5.57138 14.3381 5.28357 14.0024 4.92853 14.0024C4.57346 14.0023 4.28564 14.3381 4.28564 14.7523V17.7523C4.28564 18.995 5.14911 20.0023 6.21423 20.0023H17.7858C18.8509 20.0023 19.7144 18.995 19.7144 17.7523V14.7523C19.7144 14.3381 19.4265 14.0023 19.0715 14.0023Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .15
		})]
	})
});
const ForwardRef = forwardRef(SvgDownload);
export default ForwardRef;
